import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PullDetailPage } from './pull-detail';
import { ComponentsModule } from '../../../components/components.module';

@NgModule({
  declarations: [PullDetailPage],
  imports: [IonicPageModule.forChild(PullDetailPage), ComponentsModule],
})
export class PullDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/pull/pull-detail/pull-detail.module.ts